import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';
import { 
  FeatureSource,
  ModelBase, 
} from "@models";
import { 
  Subrace, 
} from "@dndModels";
import { SizeType } from "@dndModels/Types";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";
import FeatureSourceInput from "@dndComponents/FeatureSourceInput";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import DisplayObjects from "@dndComponents/display/DisplayObjects";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

interface Props {
  obj?: ModelBase;
}

export default function SubraceEdit({ obj: param_obj }: Props) {
  const [reloading, setReloading] = useState(false);
  const [obj, setObj] = useState<Subrace>(param_obj instanceof Subrace ? param_obj : api.applyWorkingOn(new Subrace()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <FeatureSourceInput 
      obj={obj}
      data_type="subrace"
      disabled={disabled}
      change_time={change_time}
      onChange={(changed: FeatureSource) => {
        if (changed instanceof Subrace) {
          const new_obj = obj;
          new_obj.copy(changed);
          setObj(new_obj);
        }
      }}
      header={
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            { disabled ?
              <>
                <span className="header">Race:</span> <DisplayObjects type="race" ids={obj.race_ids} />
              </>
            :
              <SelectObjectBox 
                name="Race"
                data_type="race"
                values={ obj.race_ids } 
                multiple
                disabled={disabled}
                onChange={(ids: string[]) => {
                  const new_obj = obj;
                  new_obj.race_ids = ids;
                  setObj(new_obj);
                  setChangeTime(common_util.get_time_number());
                }}
              />
            }
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            { disabled ?
              <>
                { !obj.sizes.includes(8) &&
                  <>
                    <span className="header">Size:</span> 
                    { common_util.get_size_strings(obj.sizes).join(", ") } 
                  </>
                }
              </>
            : !reloading &&
              <SelectStringBox 
                name="Size"
                options={["Tiny","Small","Medium","Large","Huge","Gargantuan","Size from Race"]}
                values={common_util.get_size_strings(obj.sizes)} 
                multiple
                disabled={disabled}
                onChange={(values: string[]) => {
                  const new_obj = obj;
                  const old_sizes = [...new_obj.sizes];
                  let new_sizes = common_util.get_size_numbers(values);
                  if (new_sizes.includes(8)) {
                    if (old_sizes.includes(8) && new_sizes.filter(o => o !== 8).length > 0) {
                      new_sizes = new_sizes.filter(o => o !== 8);
                      setReloading(true);
                    } else if (!old_sizes.includes(8) && new_sizes.filter(o => o === 8).length > 0) {
                      new_sizes = [8];
                      setReloading(true);
                    }
                  }
                  new_obj.sizes = new_sizes as SizeType[];
                  setObj(new_obj); 
                  setChangeTime(common_util.get_time_number());
                }}
              />
            }
          </Grid>
        </Grid>
      }
    />
  ); 
}